import appDownloadQr from '@/assets/app/app-download-qr.png'
import appIcon from '@/assets/app/app-icon.png'
import openInBrowserGuide from '@/assets/app/open-in-browser.png'
import slide1 from '@/assets/app/slide-1.png'
import slide2 from '@/assets/app/slide-2.png'
import slide3 from '@/assets/app/slide-3.png'
import slide4 from '@/assets/app/slide-4.png'

export type AppLaunchPlatform = 'ios' | 'android' | 'other'
export type AppLaunchTargetType = 'custom' | 'web'

export interface AppPageSlide {
  key: string
  image: string
  title: string
  subtitleLines: string[]
  imageAlt: string
}

export interface AppPlatformLaunchConfig {
  scheme?: string
  universalLink?: string
  appLink?: string
  intent?: string
  downloadUrl: string
}

export interface AppLaunchTarget {
  type: AppLaunchTargetType
  url: string
}

export const APP_PAGE_META = {
  title: '造梦次元 | 来造梦次元，造一百种世界',
  description: '来造梦次元，造一百种世界。下载造梦次元 App，体验 AI 虚拟角色互动与内容创作。',
} as const

export const APP_PAGE_LAYOUT = {
  baseWidth: 400,
  baseHeight: 800,
  carouselWidth: 360,
} as const

export const APP_PAGE_TIMING = {
  fallbackDelayMs: 1200,
  minValidDelayMs: 700,
  autoPlayIntervalMs: 2500,
  autoPlayFirstDelayMs: 2500,
  autoPlayResumeDelayMs: 5000,
  toastDurationMs: 1800,
} as const

export const APP_PAGE_GESTURE = {
  swipeDistanceRatio: 0.2,
  swipeVelocityThreshold: 0.5,
  edgeResistance: 0.35,
} as const

export const APP_PAGE_ASSETS = {
  appDownloadQr,
  appIcon,
  openInBrowserGuide,
} as const

export const APP_PAGE_SLIDES: AppPageSlide[] = [
  {
    key: 'duet',
    image: slide1,
    title: '社交分身 好友合拍',
    subtitleLines: ['全新社交体验', '和好友演出脑洞剧情'],
    imageAlt: '社交分身与好友合拍功能示意',
  },
  {
    key: 'community',
    image: slide4,
    title: '新一代内容社区',
    subtitleLines: ['全新社交体验', '和好友演出脑洞剧情'],
    imageAlt: '造梦次元内容社区功能示意',
  },
  {
    key: 'character',
    image: slide3,
    title: '@角色出镜',
    subtitleLines: ['亲手创造', '想象中一百种世界'],
    imageAlt: '角色出镜创作功能示意',
  },
  {
    key: 'parallel',
    image: slide2,
    title: '平行时空小剧场',
    subtitleLines: ['探索主线故事外', '你们的无限种可能性'],
    imageAlt: '平行时空小剧场功能示意',
  },
]

export const APP_LAUNCH_CONFIG: Record<'ios' | 'android', AppPlatformLaunchConfig> & {
  defaultDownloadUrl: string
} = {
  ios: {
    scheme: 'ciyuan://preview.ideaflow.pro',
    universalLink: '',
    downloadUrl: 'https://apps.apple.com/cn/app/%E9%80%A0%E6%A2%A6%E6%AC%A1%E5%85%83/id6475137705',
  },
  android: {
    scheme: 'ciyuan://preview.ideaflow.pro',
    appLink: '',
    intent: '',
    downloadUrl: 'https://sj.qq.com/appdetail/com.ideaflow.zmcy',
  },
  defaultDownloadUrl: '',
} as const
